import { SystemStyleObject } from '@chakra-ui/styled-system';

const tabListBaseStyle: SystemStyleObject = {
  borderBottomColor: 'transparent !important',
  _selected: {
    color: 'red',
  },
};

const tabBaseStyle: SystemStyleObject = {
  borderTopRadius: '10px',
  _focus: {
    boxShadow: 'none',
  },
  _selected: {
    color: 'red',
  },
};

const baseStyle = () => ({
  tablist: tabListBaseStyle,
  tab: tabBaseStyle,
});

const variantLine = {
  tab: {
    _selected: {
      color: 'brand.900',
      borderColor: 'brand.tertiary',
      fontWeight: '600',
    },
    _active: {
      bg: 'brand.1000',
    },
  },
};

export const Tabs = {
  baseStyle,
  variants: {
    line: variantLine,
  },
  defaultProps: {
    colorScheme: 'brand.1000',
  },
};
